import { render, staticRenderFns } from "./program-monitor2@.vue?vue&type=template&id=3894207d&"
import script from "./program-monitor2@.vue?vue&type=script&lang=ts&"
export * from "./program-monitor2@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports